import { render } from "./RedCheckout.vue?vue&type=template&id=415ce160&scoped=true&ts=true"
import script from "./RedCheckout.vue?vue&type=script&lang=ts"
export * from "./RedCheckout.vue?vue&type=script&lang=ts"

import "./RedCheckout.vue?vue&type=style&index=0&id=415ce160&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415ce160"]])

export default __exports__